import React from "react"
import {connect} from "react-redux"
import {RecognitionAreaData} from "../../util/interfaceData"
import SimpleFieldStyles from "./simpleField.less"

export class SimpleField extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
    }

    render() {
        const simpleField = this.props.recognitionArea.map((item: RecognitionAreaData, index: number) => {
            return [
                <tbody key={index + item.key}>
                    <tr>
                        <td valign="top" title={item.key} className={SimpleFieldStyles.tdStyle}>
                            {item.key}
                        </td>
                        <td valign="top" className={SimpleFieldStyles.tdText}>
                            {item.value}
                        </td>
                    </tr>
                </tbody>,
            ]
        })
        return [simpleField]
    }
}
export default connect((state: any) => {
    return {
        recognitionArea: state.recognitionArea,
    }
})(SimpleField)
